// @flow
import styled from 'styled-components';

export const Inner = styled.div`
  &&& {
    margin: 12px 0 36px;
  }
`;
